import { forwardRef } from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  Switch,
} from '@mui/material';

interface Props {
  label?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  info?: string;
  error?: string;
  title?: string;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  appearance?: 'switch' | 'radio' | 'checkbox';
}

const INPUT_WIDTH = 35;
const GAP = 10;

export const SwitchInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      value,
      onChange,
      info,
      error,
      title,
      required,
      disabled,
      name,
      appearance = 'switch',
    },
    forwardedRef,
  ) => {
    return (
      <FormControl error={!!error}>
        <FormControlLabel
          control={(() => {
            switch (appearance) {
              case 'switch':
                return (
                  <Switch
                    inputRef={forwardedRef}
                    required={required}
                    sx={{ margin: 0, width: INPUT_WIDTH }}
                  />
                );
              case 'radio':
                return (
                  <Radio
                    inputRef={forwardedRef}
                    required={required}
                    disableRipple
                  />
                );
              case 'checkbox':
                return (
                  <Checkbox
                    required={required}
                    inputRef={forwardedRef}
                    sx={{ p: 0 }}
                  />
                );

              default:
                return appearance satisfies never;
            }
          })()}
          label={label}
          name={name}
          title={title}
          checked={value}
          onChange={(_e, checked) => onChange?.(checked)}
          disabled={disabled}
          sx={{ margin: 0, gap: `${GAP}px`, alignItems: 'flex-start' }}
        />
        {error ? (
          <FormHelperText
            error
            sx={{
              ml: `${INPUT_WIDTH + GAP}px`,
              fontSize: 12,
              letterSpacing: 'inherit',
            }}
          >
            {error}
          </FormHelperText>
        ) : null}
        {info ? (
          <FormHelperText
            error={false}
            sx={{
              ml: `${INPUT_WIDTH + GAP}px`,
              fontSize: 12,
              letterSpacing: 'inherit',
            }}
          >
            {info}
          </FormHelperText>
        ) : null}
      </FormControl>
    );
  },
);

SwitchInput.displayName = 'SwitchInput';
